import { privateKeyToAccount } from "viem/accounts";

/**
 * Currency
 */
export class Currency {
  constructor(decimals, symbol, name,totalSupply) {
    this.decimals = decimals;
    this.symbol = symbol;
    this.name = name;
    this.totalSupply=totalSupply;
  }
}

/**
 * Currency
 * @type {Currency}
 */
export const ETHER = new Currency(18, 'ETH', 'ETH')

/**
 * Token
 */
export class Token extends Currency {
  constructor(chainId, address, decimals, symbol, name,totalSupply) {
    super(decimals, symbol, name,totalSupply)
    this.chainId = chainId;
    this.address = address;
  }

  equals(other) {
    if (this === other) {
      return true
    }
    return this.chainId === other.chainId && this.address === other.address
  }
}

export class NFTToken extends Currency {
  constructor(chainId, address, symbol, name,totalSupply) {
    super(symbol, name,totalSupply)
    this.chainId = chainId;
    this.address = address;
  }
}
export class CustomWallet {
  constructor(address, name, privateKey) {
    this.address = address
    this.name = name
    this.privateKey = privateKey
    this.account = privateKeyToAccount(this.privateKey)
  }
}
